import React from 'react'

interface IProps {
  children: React.ReactNode
  className?: string
  /** Semantic heading level rendered as the h-element (1–6). Defaults to 1.
   *  Callers that are page-section sub-headings should pass level={2} or lower. */
  level?: 1 | 2 | 3 | 4 | 5 | 6
}

const Heading = ({ children, className, level = 1 }: IProps) => {
  const Tag = `h${level}` as const
  return (
    <Tag className={`font-semibold text-[28px] leading-[38px] ${className}`}>
      {children}
    </Tag>
  )
}

export default Heading
